import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import Banner from 'components/common/Banner/Banner'
import Popover from 'components/common/Popover'

const Kit = ({
  className,
  kit: {
    commerceItemId,
    description,
    kitId,
    name,
    price,
    totalPrice,
    tpmsToolTipMessage,
    image,
    icon
  } = {},
  ...props
}) =>
  <CustomBanner data-at-appointment-kit className={ className } { ...props } >
    <KitIcon data-at-kit-icon src={ image || icon } alt="" />
    <Wrapper>
      <Title data-at-kit-title>
        { name }
        {
          tpmsToolTipMessage &&
            <CustomPopover small>
              <Content>{ tpmsToolTipMessage }</Content>
            </CustomPopover>
        }
      </Title>
      <Content data-at-kit-description>{ description }</Content>
    </Wrapper>
  </CustomBanner>

Kit.propTypes = {
  className: PropTypes.string,
  kit: PropTypes.shape()
}

export default Kit

const CustomBanner = styled(Banner)`
  margin: 0 0 10px;
  ${Mixin.responsive('padding', '12px 17px 12px 60px', '11px 15px')}
  ${props => props.success && css`
    border: 1px solid ${Theme.colors.light_grey};
  `}

  &:last-child {
    margin-bottom: 0;
  }

  & [data-icon] {
    display: none;
  }
`

const Image = styled.img`
  position: absolute;
  top: 50%;
  max-width: 100%;
  transform: translateY(-50%);
  ${Media.mobile`
    display: none;
  `}
`

const Title = styled.div`
  display: inline-block;
  font-weight: 600;
  line-height: 19px;
  vertical-align: middle;
  color: ${Theme.colors.dark_grey};
`

const Content = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 17px;
  color: ${Theme.colors.dark_grey};
`

const Wrapper = styled.div`
  ${Media.desktop`
    display: inline-block;
    vertical-align: middle;
  `}
  ${Mixin.responsive('padding-left', '108px', '0')}
`

const CustomPopover = styled(Popover)`
  margin-left: 8px;
  line-height: 0;
  vertical-align: middle;

  & [data-tooltip] {
    margin-right: 0;
  }
`

const KitIcon = styled(Image)`
  width: 24px;
  height: 24px;
`
